import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentQueueServiceTime } from "../../../../../../@types/attendance-local-department-queue-service-time";

export type AttendanceLocalDepartmentQueueServiceTimeCreateData = Pick<
    AttendanceLocalDepartmentQueueServiceTime,
    | "fila"
    | "tempo_presencial"
    | "tempo_online"
> & {
    servico_id: number;
}

export function useAttendanceLocalDepartmentQueueServiceTimeCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "queue", "service-time", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentQueueServiceTimeCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentQueueServiceTime>(
                '/cms/tempo_servico_fila/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time', 'list']
            });
            toast.success("Tempo de serviço criado com sucesso!");
            history.replace({
                pathname: history.location.pathname.replace(/\/novo$/, ""),
                state: { showSuccessAlert: true }
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
